import SelfAssign from './SelfAssign';

export default SelfAssign;
